import { useBrowseIntegrationCountApi } from '@aibees/elephant/hooks/integration/use-browse-integration-count-api';
import {
  IntegrationConfig,
  IntegrationStatus,
} from '@aibees/elephant/types/integration';
import { useMemo } from 'react';

export const useIntegrationPrepareDataBasedOnCount = (
  config: IntegrationConfig[]
): IntegrationConfig[] => {
  const { data } = useBrowseIntegrationCountApi();
  return useMemo(() => {
    return config.map((item) => {
      const value = item?.type !== undefined ? data?.[item.type] : undefined;

      let status = IntegrationStatus.ComingSoon;
      if (value?.available && Number(value.count) > 0) {
        status = IntegrationStatus.Connected;
      } else if (value?.available) {
        status = IntegrationStatus.Available;
      }

      return {
        ...item,
        status,
      };
    });
  }, [config, data]);
};
